import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Utensils, MoonStar, CheckCircle2 } from 'lucide-react';
export function FeaturesSection() {
  const coreFeatures = ['El plan de acción detallado de 72 horas.', 'La lista de los 7 irritantes invisibles que debes evitar de noche.', 'La técnica de "Doble Vaciado" explicada paso a paso.', 'Estrategias de hidratación inteligente para el día y la noche.', 'Diario de seguimiento para registrar tu progreso real.'];
  return <section className="bg-navy-950 py-20 md:py-28 relative text-cream-50 border-t border-navy-800" data-id="element-62">
      <div className="container mx-auto px-4" data-id="element-63">
        <div className="max-w-[1000px] mx-auto" data-id="element-64">
          <FadeIn data-id="element-65">
            <div className="text-center mb-16" data-id="element-66">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6" data-id="element-67">
                Qué incluye la guía
              </h2>
              <p className="text-lg text-cream-100/70 max-w-2xl mx-auto" data-id="element-68">
                Un paquete digital completo, diseñado para ser fácil de leer,
                rápido de aplicar y enfocado en resultados prácticos.
              </p>
            </div>
          </FadeIn>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-69">
            {/* Main Guide Card */}
            <div className="lg:col-span-7" data-id="element-70">
              <FadeIn className="h-full" data-id="element-71">
                <div className="bg-navy-900 rounded-3xl p-8 md:p-10 border border-gold-500/20 shadow-2xl h-full relative overflow-hidden" data-id="element-72">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-gold-500/5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-73" />

                  <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-74">
                    <div className="w-12 h-12 rounded-xl bg-gold-500/10 flex items-center justify-center border border-gold-500/20" data-id="element-75">
                      <BookOpen className="text-gold-400" size={24} data-id="element-76" />
                    </div>
                    <h3 className="text-2xl font-heading font-bold text-white" data-id="element-77">
                      Protocolo Próstata: Noches en Paz
                    </h3>
                  </div>

                  <p className="text-cream-100/80 mb-8 leading-relaxed relative z-10" data-id="element-78">
                    La guía principal en formato PDF con el sistema completo
                    para calmar tu vejiga y mejorar tu descanso nocturno.
                  </p>

                  <ul className="space-y-4 relative z-10" data-id="element-79">
                    {coreFeatures.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-80">
                        <CheckCircle2 className="text-gold-500 shrink-0 mt-1" size={20} data-id="element-81" />
                        <span className="text-cream-100/90" data-id="element-82">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </FadeIn>
            </div>

            {/* Bonuses Column */}
            <div className="lg:col-span-5 space-y-8" data-id="element-83">
              <FadeIn delay={0.1} className="h-[calc(50%-1rem)]" data-id="element-84">
                <div className="bg-navy-800 rounded-3xl p-8 border border-navy-700 shadow-xl h-full relative" data-id="element-85">
                  <div className="absolute top-4 right-4 bg-gold-500/20 text-gold-400 text-xs font-bold px-3 py-1 rounded-full" data-id="element-86">
                    BONO 1
                  </div>
                  <div className="flex items-center gap-4 mb-4" data-id="element-87">
                    <div className="w-10 h-10 rounded-lg bg-navy-900 flex items-center justify-center" data-id="element-88">
                      <Utensils className="text-cream-100/70" size={20} data-id="element-89" />
                    </div>
                    <h4 className="text-lg font-bold text-white pr-16" data-id="element-90">
                      Plan de Cenas (7 Días)
                    </h4>
                  </div>
                  <p className="text-sm text-cream-100/70 leading-relaxed" data-id="element-91">
                    Un menú anti-nicturia con recetas fáciles y rápidas,
                    diseñadas para no irritar tu vejiga antes de dormir. Incluye
                    lista de compras.
                  </p>
                </div>
              </FadeIn>

              <FadeIn delay={0.2} className="h-[calc(50%-1rem)]" data-id="element-92">
                <div className="bg-navy-800 rounded-3xl p-8 border border-navy-700 shadow-xl h-full relative" data-id="element-93">
                  <div className="absolute top-4 right-4 bg-gold-500/20 text-gold-400 text-xs font-bold px-3 py-1 rounded-full" data-id="element-94">
                    BONO 2
                  </div>
                  <div className="flex items-center gap-4 mb-4" data-id="element-95">
                    <div className="w-10 h-10 rounded-lg bg-navy-900 flex items-center justify-center" data-id="element-96">
                      <MoonStar className="text-cream-100/70" size={20} data-id="element-97" />
                    </div>
                    <h4 className="text-lg font-bold text-white pr-16" data-id="element-98">
                      Guía de Emergencia 3AM
                    </h4>
                  </div>
                  <p className="text-sm text-cream-100/70 leading-relaxed" data-id="element-99">
                    Un protocolo de 5 pasos exactos sobre qué hacer cuando ya te
                    despertaste, para ayudarte a volver a conciliar el sueño
                    rápidamente.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>
        </div>
      </div>
    </section>;
}